import React from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import cloneDeep from 'lodash/cloneDeep';
import Avatar from '@mui/material/Avatar';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SortableFilterTable from '../SortableFilterTable.jsx';
import dayjs from 'dayjs';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RecyclerItem from './RecyclerItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import Popover from '@mui/material/Popover';
import {
    Card,
    CardContent,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Paper,
}
    from '@mui/material/'

//import { useHtml5QrCodeScanner } from 'react-html5-qrcode-reader';

function Recyclers(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration')
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime')
    dayjs.extend(relativeTime)

    const [searchValue, setSearchValue] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [recyclers, setRecyclers] = React.useState([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedRow, setSelectedRow] = React.useState(-1);
    const [showFilters, setShowFilters] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [filtersStatus, setFiltersStatus] = React.useState('Active');
    const [filtersOpenOrders, setFiltersOpenOrders] = React.useState(false);
    const [filtersPaidOrders, setFiltersPaidOrders] = React.useState(false);
    const html5QrCodeScannerFile = process.env.PUBLIC_URL + '/scripts/html5-qrcode.min.js'; // <-- this file is in /public.
    //const { Html5QrcodeScanner } = useHtml5QrCodeScanner(html5QrCodeScannerFile);
    const [successReads, setSuccessReads] = React.useState([]);
    //React.useEffect(() => {
    //    if (Html5QrcodeScanner) {
    //        // Creates anew instance of `HtmlQrcodeScanner` and renders the block.
    //        let html5QrcodeScanner = new Html5QrcodeScanner(
    //            "reader",
              
    //            { fps: 10, qrbox: { width: 350, height: 150 }, formatsToSupport: [Html5QrcodeSupportedFormats.PDF_417] },
    //    /* verbose= */ false);
    //        html5QrcodeScanner.render(
    //            (data) => {
    //                let temp = cloneDeep(successReads);
    //                temp.push(data);
    //                setSuccessReads(temp);
    //            },
    //            (err) => console.log('err ->', err)
    //        );
    //    }
    //}, [Html5QrcodeScanner]);

    function showLoadingIndicator() {
        return <LoadingIndicator Message={'Loading'} />
    }

    function adminRecyclerSearch() {
        // if (searchValue.trim().length != 0) {
        let postData = {
            searchValue: searchValue.trim(),
            status: filtersStatus,
            hasOpenOrders: filtersOpenOrders,
            hasPaidOrders: filtersPaidOrders
        }

        setIsLoading(true);
        TokenService.post(postData, 'Admin_ReturnerSearch')

            .then((response) => {
                setIsLoading(false);
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    setRecyclers(jsonData);
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });
                }

            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
                setIsLoading(false);
            });
        //}
        //else {
        //    enqueueSnackbar("Can't be blank", {
        //        variant: 'error',
        //    });
        //}
    }

    function handleKeydown(e) {
        const { key, keyCode } = e;
        //  console.log(key, keyCode);
        if (keyCode === 13) {
            adminRecyclerSearch();
        }
    }

    function handleRowClick(e, recycler) {
        if (recycler.ID == selectedRow) {
            // same row clicked again
            setSelectedRow(0);
        }
        else {
            setSelectedRow(recycler.ID);
        }
    }

    function handleRecyclerUpdated(recycler) {
        let tempRecyclers = [];
        for (let i = 0; i < recyclers.length; i++) {
            if (recyclers[i].ID == recycler.ID) {
                tempRecyclers.push(recycler);
            }
            else {
                tempRecyclers.push(recyclers[i]);
            }
        }
        setRecyclers(tempRecyclers);
    }

    function buildRecyclers() {
        if (recyclers.length === 0) {
            return (<div>No results</div>)
        }

        let tableData = [];


        let columns = [
            {
                name: 'Photo',
                mappedProperty: 'Photo',
                dataType: 'none',
                canFilter: false
            },
            {
                name: 'First',
                mappedProperty: 'FirstName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Last',
                mappedProperty: 'LastName',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Email',
                mappedProperty: 'EmailAddress',
                dataType: 'string',
                canFilter: true
            },
            {
                name: 'Open',
                mappedProperty: 'OpenOrders',
                dataType: 'numeric',
                canFilter: true
            },
            {
                name: 'Completed',
                mappedProperty: 'CompletedOrders',
                dataType: 'numeric',
                canFilter: true
            }

        ]

        return (<div>
            {recyclers.map((recycler, index) => {
                let dataItem = cloneDeep(recycler);
                dataItem.Photo = <Avatar
                    alt="Photo"
                    src={recycler.ReturnerPhoto}
                    sx={{ width: 40, height: 40, alignSelf: 'center' }}
                />
                tableData.push(dataItem);
            })
            }
            <div style={{display:'flex', justifyContent:'flex-end'} }>Results: {recyclers.length}</div>
            <SortableFilterTable data={tableData} columns={columns} expandRow={(data) => handleRowExpanded(data)} uniqueIdentifierProperty={'ID'} />
        </div>)
    }

    function handleRowExpanded(recycler) {
        return <RecyclerItem recycler={recycler} onUpdate={(recycler) => handleRecyclerUpdated(recycler)} />
    }

    return (

        <div style={{ marginBottom: '200px' }}>
            {isLoading ?
                showLoadingIndicator()
                :

                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom:'5px', marginTop:'5px' }}>
                        <TextField value={searchValue} label='Anything' onKeyDown={(e) => handleKeydown(e)} onChange={(e) => setSearchValue(e.target.value)} />
                        <Fab onClick={adminRecyclerSearch} style={{ marginLeft: '15px',backgroundColor: 'var(--sipzee-green)' }}><SearchIcon /></Fab>

                        <Fab style={{ marginLeft: '15px', backgroundColor: 'var(--sipzee-gray)' }} onClick={(e) => { setAnchorEl(e.currentTarget); setShowFilters(true); }}>
                            <FilterListIcon sx={{ color: 'var(--sipzee-gray-3)' }} />
                        </Fab>

                        <Popover

                            open={showFilters}
                            anchorEl={anchorEl}
                            onClose={(event) => { setAnchorEl(null); setShowFilters(false); }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >

                            <Paper style={{ padding: '15px' }}>
                                <div>
                                    <FormControl>
                                        <FormLabel>Status</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue={filtersStatus}
                                            name="radio-buttons-group"
                                            onChange={(e) => setFiltersStatus(e.target.value) }
                                        >
                                            <FormControlLabel value="Active" control={<Radio />} label="Active" />
                                            <FormControlLabel value="Inactive" control={<Radio />} label="Inactive" />
                                            <FormControlLabel value="All" control={<Radio />} label="All" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <div style={{marginTop:'5px', paddingTop:'5px', borderTop:'1px solid #efefef'} }>
                                    <FormGroup>
                                        <FormLabel>Orders</FormLabel>
                                        <FormControlLabel control={<Checkbox checked={filtersOpenOrders} onChange={(e) => setFiltersOpenOrders(e.target.checked)} />} label="Open Orders" />
                                        <FormControlLabel control={<Checkbox checked={filtersPaidOrders} onChange={(e) => setFiltersPaidOrders(e.target.checked)} />} label="Paid Orders" />
                                    </FormGroup>
                                </div>
                            </Paper>

                        </Popover>
                    </div>
                    <div>

                        {buildRecyclers()}

                        {/*<div id='reader'></div>*/}
                        {/*{successReads.map((itm, i) => {*/}
                        {/*    return <div>{itm }</div>*/}
                        {/*}) }*/}
                    </div>
                </div>

            }
        </div>
    )
}
export default Recyclers;